export default __webpack_public_path__ + "static/media/work-experience.9ff3072f.jpg";